import React, { useContext, useEffect } from "react";
import Rating from "react-rating";
import CardDiv from "modules/common/card-div/CardDiv";
import { ProgressBar } from "react-bootstrap";
import { Button } from "antd";
import { isEmpty } from "lodash";
import { DownloadOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCSATFeedback } from "./store";
import { FeedbackDate } from "./FeedbackTab";
import xlsx from "json-as-xlsx";
import moment from "moment";

function CsatFeedback({ data, csatLength }) {
  const { startDate, endDate } = useContext(FeedbackDate);
  const {csatDownloadData, csatDownLoading, fetchCSATFeedbackDownload} = useCSATFeedback();

  useEffect(()=>{
    fetchCSATFeedbackDownload(startDate.valueOf(), endDate.valueOf());
  },[startDate])


  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      return {
        ...el,
        userName: el.user ? el.user?.first_name : "",
        userPhoneNumber: el.user ? el.user?.phone_number : "",
        userGender: el.user ? el.user?.gender : "",
        userEmail: el.user ? el.user?.email : "",
        agentName: el.rep ? el.rep?.first_name : "",
        agentUserId: el.rep ? el.rep?.id : "",
        updatedAt: moment(el.updatedAt).format("DD-MM-YYYY HH:mm:ss"),
        createdAt: moment(el.createdAt).format("DD-MM-YYYY HH:mm:ss"),
        change_coach: el.change_coach === 0 ? "No" : "Yes",
        doubt_resolved: el.doubt_resolved === 0 ? "No" : "Yes",
      };
    });
    const data = [
      {
        sheet: "csatFeedbacks",
        columns: [
          { label: "Case Id", value: "case_id" },
          { label: "Customer Name", value: "userName" },
          { label: "Customer Phone Number", value: "userPhoneNumber" },
          { label: "Customer Email Id", value: "userEmail" },
          { label: "Customer Gender", value: "userGender" },
          { label: "Agent Name", value: "agentName" },
          { label: "Agent User Id", value: "agentUserId" },
          { label: "Call Type", value: "tag" },
          { label: "Preffered Language", value: "preffered_language" },
          {
            label: "Did your hair coach resolve your doubts?",
            value: "doubt_resolved",
          },
          { label: "Rate your traya coach ?", value: "rate_your_coach" },
          { label: "Are you happy with traya ?", value: "happy_with_traya" },
          {
            label: "Do you want to change your coach ?",
            value: "change_coach",
          },
          {
            label: "Tell us more. How can we serve better ?",
            value: "tell_us_more",
          },
          {
            label: "Created At",
            value: "createdAt",
          },
          {
            label: "Updated At",
            value: "updatedAt",
          },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: `CSAT Feedbacks`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <CardDiv
      title={
        <div>
          <div className="d-flex gap-3 align-items-center">
            <div className="w-50">Rating of Coach</div>
            <div className="w-50 d-flex justify-content-between align-items-center">
              <div>Happy Customer</div>
              <div className="my-n2">
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  onClick={() => ExcelDownload(csatDownloadData?.feedbacks)}
                  disabled={isEmpty(csatDownloadData?.feedbacks)}
                >
                  Download
                </Button>
              </div>
            </div>
          </div>
        </div>
      }
      component={
        <div className="d-flex justify-content-between mt-n2 w-100">
          <div className="w-50">
            <div className="d-flex gap-3">
              <Rating
                initialRating={5}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.coach_rating_5 / csatLength) * 100 }
                />
              </div>
              <div className="fw-bold">{data?.coach_rating_5}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={4}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.coach_rating_4 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.coach_rating_4}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={3}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.coach_rating_3 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.coach_rating_3}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={2}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.coach_rating_2 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.coach_rating_2}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={1}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.coach_rating_1 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.coach_rating_1}</div>
            </div>
          </div>
          <div className="w-50">
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={5}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.happy_rate_5 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.happy_rate_5 }</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={4}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.happy_rate_4 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.happy_rate_4}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={3}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.happy_rate_3 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.happy_rate_3}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={2}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.happy_rate_2 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.happy_rate_2}</div>
            </div>
            <div className="d-flex align-items-center gap-3">
              <Rating
                initialRating={1}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.happy_rate_1 / csatLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.happy_rate_1}</div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default CsatFeedback;
